<script setup lang="ts">
import LoyaltyCreateContainer from './LoyaltyCreateContainer.vue'
const { t } = useI18n()
const { goToExplanation, radioGroup, radioValue } = useLoyalty()
</script>

<template>
  <LoyaltyCreateContainer>
    <div class="p-10 text-center">
      <AppRadioCard
        v-model="radioValue"
        class="mb-10 grid grid-cols-2 gap-4"
        :is-only-image="true"
        :options="radioGroup"
      />
      <p
        class="cursor-pointer font-semibold text-primary underline hover:text-primary/80"
        @click="() => goToExplanation(true)"
      >
        {{ t('pages.loyalty.create.instructions.softNotFound') }}
      </p>
    </div>
  </LoyaltyCreateContainer>
</template>
